import SummaryCardComponent from './SummaryCard';
import SummaryDataItemComponent from './SummaryDataItem';
import InventoryDataItemComponent from './InventoryDataItem';

const SummaryCard = SummaryCardComponent;
const SummaryDataItem = SummaryDataItemComponent;
const InventoryDataItem = InventoryDataItemComponent;

export default SummaryCard;
export { SummaryDataItem, InventoryDataItem };
